import { useState } from "react";

/**
 * 🔍 useEmployeeFilters Hook
 * يدير جميع states الفلترة والبحث للموظفين والأرشيف
 */
export function useEmployeeFilters() {
  // ============== EMPLOYEE SEARCH & FILTER STATES ==============
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDepartment, setFilterDepartment] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterCompany, setFilterCompany] = useState("");
  const [filterStatusSearch, setFilterStatusSearch] = useState("");
  const [filterCompanySearch, setFilterCompanySearch] = useState("");
  const [showAllEmployees, setShowAllEmployees] = useState(false);

  // ============== ARCHIVE FILTER STATES ==============
  const [archiveSearch, setArchiveSearch] = useState("");
  const [archiveFilterCompany, setArchiveFilterCompany] = useState("");
  const [archiveFilterDateFrom, setArchiveFilterDateFrom] = useState("");
  const [archiveFilterDateTo, setArchiveFilterDateTo] = useState("");
  const [archiveFilterWorkingCompany, setArchiveFilterWorkingCompany] = useState("");
  const [archiveFilterDepartment, setArchiveFilterDepartment] = useState("");
  const [archiveFilterCompanySearch, setArchiveFilterCompanySearch] = useState("");
  const [archiveFilterWorkingCompanySearch, setArchiveFilterWorkingCompanySearch] = useState("");
  const [archiveFilterDepartmentSearch, setArchiveFilterDepartmentSearch] = useState("");

  // ============== HELPER FUNCTION: CLEAR ALL FILTERS ==============
  const clearAllFilters = () => {
    setSearchTerm("");
    setFilterDepartment("");
    setFilterStatus("");
    setFilterCompany("");
    setFilterStatusSearch("");
    setFilterCompanySearch("");
    setShowAllEmployees(false);
  };

  const clearArchiveFilters = () => {
    setArchiveSearch("");
    setArchiveFilterCompany("");
    setArchiveFilterDateFrom("");
    setArchiveFilterDateTo("");
    setArchiveFilterWorkingCompany("");
    setArchiveFilterDepartment("");
    setArchiveFilterCompanySearch("");
    setArchiveFilterWorkingCompanySearch("");
    setArchiveFilterDepartmentSearch("");
  };

  // ============== RETURN PUBLIC API ==============
  return {
    // Employee filters
    searchTerm,
    setSearchTerm,
    filterDepartment,
    setFilterDepartment,
    filterStatus,
    setFilterStatus,
    filterCompany,
    setFilterCompany,
    filterStatusSearch,
    setFilterStatusSearch,
    filterCompanySearch,
    setFilterCompanySearch,
    showAllEmployees,
    setShowAllEmployees,

    // Archive filters
    archiveSearch,
    setArchiveSearch,
    archiveFilterCompany,
    setArchiveFilterCompany,
    archiveFilterDateFrom,
    setArchiveFilterDateFrom,
    archiveFilterDateTo,
    setArchiveFilterDateTo,
    archiveFilterWorkingCompany,
    setArchiveFilterWorkingCompany,
    archiveFilterDepartment,
    setArchiveFilterDepartment,
    archiveFilterCompanySearch,
    setArchiveFilterCompanySearch,
    archiveFilterWorkingCompanySearch,
    setArchiveFilterWorkingCompanySearch,
    archiveFilterDepartmentSearch,
    setArchiveFilterDepartmentSearch,

    // Helper methods
    clearAllFilters,
    clearArchiveFilters,
  };
}
